module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content report-box",
    staticStyle: {
      "min-height": "125px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "m-b-md"
  }, [_c('div', {
    staticClass: "radio radio-info radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period),
      expression: "period"
    }],
    attrs: {
      "type": "radio",
      "value": "all_time",
      "name": "completed_jobs_period",
      "id": "completed_jobs_period_all_time"
    },
    domProps: {
      "checked": _vm._q(_vm.period, "all_time")
    },
    on: {
      "__c": function($event) {
        _vm.period = "all_time"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "completed_jobs_period_all_time"
    }
  }, [_vm._v("All Time")])]), _vm._v(" "), _c('div', {
    staticClass: "radio radio-info radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period),
      expression: "period"
    }],
    attrs: {
      "type": "radio",
      "value": "date_range",
      "name": "completed_jobs_period",
      "id": "completed_jobs_period_range"
    },
    domProps: {
      "checked": _vm._q(_vm.period, "date_range")
    },
    on: {
      "__c": function($event) {
        _vm.period = "date_range"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "completed_jobs_period_range"
    }
  }, [_vm._v("Date Range")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.periodSelectedIsDateRange),
      expression: "periodSelectedIsDateRange"
    }],
    staticClass: "form-group"
  }, [_c('date-range', {
    attrs: {
      "max-date": _vm.yesterday,
      "name": "date_range"
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer text-right"
  }, [_c('ladda-button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "on-click": _vm.handleGenerateReport
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download fa-fw"
  }), _vm._v(" Download XLS\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("Completed Jobs Report")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-503b8fb3"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/CompletedJobsReport.vue
// module id = 999
// module chunks = 0